module.exports = __webpack_public_path__ + "static/media/sg10tj0.05dd2ee7.png";